import EventDispatcher from 'scripts/base/EventDispatcher'

const dispatcher = new EventDispatcher()

module.exports = { dispatcher }



// WEBPACK FOOTER //
// ./assets/js/components/search/SearchDispatcher.jsx